import { gql } from "@apollo/client";
import { PAGE_INFO_FRAGMENT } from "@/hooks/usePagination";
import type { PaginationVariables } from "@/components/Pagination/Pagination";
import type { ApplicationStatus } from "./[applicationId]/mutations";

export interface MembershipApplicationPerson {
  pgaId: string;
  displayName: string;
  primarySection: {
    id: string;
    name: string;
  } | null;
}

export interface MembershipApplicationNode {
  id: string;
  applicationType: string;
  status: ApplicationStatus;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  profilePhotoUrl: string | null;
  createdAt: string;
  submittedAt: string | null;
  updatedAt: string;
  person: MembershipApplicationPerson;
}

export interface MembershipApplicationsQueryResponse {
  membershipApplications: {
    nodes: MembershipApplicationNode[];
    totalCount: number;
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string;
      endCursor?: string;
    };
  };
}

export interface MembershipApplicationsQueryVariables extends PaginationVariables {
  applicationType?: string;
  status?: ApplicationStatus;
  search?: string;
  sectionId?: string;
  reviewerId?: string;
  unassigned?: boolean;
  submittedAfter?: string;
}

export const MEMBERSHIP_APPLICATIONS_QUERY = gql`
  query MembershipApplications(
    $first: Int
    $last: Int
    $before: String
    $after: String
    $applicationType: MembershipApplicationTypeEnum
    $status: MembershipApplicationStatusEnum
    $search: String
    $sectionId: ID
    $reviewerId: ID
    $unassigned: Boolean
    $submittedAfter: ISO8601Date
  ) {
    membershipApplications(
      first: $first
      last: $last
      before: $before
      after: $after
      applicationType: $applicationType
      status: $status
      search: $search
      sectionId: $sectionId
      reviewerId: $reviewerId
      unassigned: $unassigned
      submittedAfter: $submittedAfter
    ) {
      nodes {
        id
        applicationType
        status
        firstName
        lastName
        email
        profilePhotoUrl
        createdAt
        submittedAt
        updatedAt
        person {
          pgaId
          displayName
          primarySection {
            id
            name
          }
        }
      }
      ...PageInfo
    }
  }
  ${PAGE_INFO_FRAGMENT}
`;
